var scalebar =
webpackJsonp_name_([9],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(66);


/***/ },

/***/ 66:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(67);

/***/ },

/***/ 67:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _scalebarControl = __webpack_require__(68);

	var _scalebarControl2 = _interopRequireDefault(_scalebarControl);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var loader = {
	    name: 'us:scalebar',

	    extends: 'viewport',

	    constructor: function (_ScalebarControl) {
	        _inherits(hackScalebar, _ScalebarControl);

	        function hackScalebar(uScope, viewport) {
	            _classCallCheck(this, hackScalebar);

	            // Polluting the viewport is a temp hack till I find a better way of handling however this is used.
	            var _this = _possibleConstructorReturn(this, (hackScalebar.__proto__ || Object.getPrototypeOf(hackScalebar)).call(this, uScope, viewport));

	            viewport.scaleBar = _this;

	            uScope.events.on('uScope:command:log-settings', function (log) {
	                log('--- enabled: Rotation Dial');
	            });
	            return _this;
	        }

	        return hackScalebar;
	    }(_scalebarControl2.default)
	};

	_publicApi2.default.plugins.register(loader);

/***/ },

/***/ 68:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ScaleBarControl;

	var _lodashLite = __webpack_require__(9);

	var _ = _interopRequireWildcard(_lodashLite);

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _objects = __webpack_require__(7);

	var _helpers = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	var defaults = {
	    layout: { 'divClass': _defines2.default.clsDIVOUTERSCALEBAR, 'precinct': 'BR', 'order': 2, 'canBePlaced': true }
	};

	function ScaleBarControl(uScope, viewport) {
	    var self = this;
	    var isLoaded = false; // scale bar has been 'loaded'

	    var jVpDiv = viewport.vpDivGet('outer');
	    var jScaleBarOuter; // the outer div - implemented to manage the scale bar rotation
	    var jScaleBar; // the inner div
	    var jTextDiv;
	    var jMagDiv;
	    var jRotateKnob;
	    var jKnobText;

	    var scaleBarSpecs = { // scale bar settings
	        'minWidth': 60,
	        'minHeight': 20, // resize limits
	        'maxWidth': 1000,
	        'maxHeight': 20,
	        'micronsAt20x': 50, // initial scale report, overridden by scaleBar resize
	        'micronsAt40x': 25, // initial scale report, overridden by scaleBar resize
	        'micronsAt100x': 25 // initial scale report, overridden by scaleBar resize
	    };
	    var bReportPixels_ = false; // report scale bar length in pixels instead of microns
	    var prefVisibleDef = true; // scalebar visibility preference default

	    var scaleLenMicCur_; // current scale bar length in microns
	    var bIsFitZoomCur_; // true/false current zoom is fit zoom
	    var angleDeg = 0.0; // current rotation angle of scale bar
	    var crBox_ = new _objects.cRect(0, 0, 1, 1); // bounding box of rotated scale bar

	    var navModesImHiddenIn = {}; // what navigation modes not to display the label

	    var layout = _.clone(defaults.layout); // scale bar layout info, clone the global set so I can modify it
	    var reLayout = viewport.overLayout.refreshPrecinct;

	    //............................................ construct_ local
	    var construct_ = function construct_() {
	        if (_defines2.default.ENABLESCALEBAR == false) return; // if the scalebar has been disabled, don't load it

	        navModesImHiddenIn[_defines2.default.eNavModes.nmRasterScan] = true; // hide scale bar in rasterscan mode
	        load_(); // load the scalebar
	    };
	    //............................................ show() public
	    self.show = function (bShow) {
	        if (isLoaded == false) return;
	        //debug-only viewport.log('scaleBar: show: input is: ' + bShow + '   pref is: ' + uScope.prefGet(us.clsDIVSCALEBAR, prefVisibleDef) );

	        // prevent show if preference is not to show
	        if (uScope.prefGet(_defines2.default.clsDIVSCALEBAR, prefVisibleDef) == false) jScaleBarOuter.hide();else if (bShow == true) jScaleBarOuter.show();else jScaleBarOuter.hide();

	        reLayout(layout.precinct); // layout just this overlay's precinct
	    };
	    //............................................ resize() public
	    // This function resizes the scale bar.
	    // parameters:
	    //        action:    'zoom' or 'resize' (default if undefined)
	    //
	    //    Note: the scalebar's inner div's width is set by that of the outer div even though the
	    //            resize event handler is on the inner div.  This solved a problem that the resize
	    //            cursor seemed to lead the element and stop resize unless you drag slowly.

	    self.resize = function (action) {
	        if (_defines2.default.ENABLESCALEBAR == false || isLoaded == false) return;

	        // note that a zoom change of fit to fit is handled as a resize
	        //    b/c the previous zoom is really the double click (toggle zoom) value
	        if (action == 'zoom' && bIsFitZoomCur_ == true && viewport.isFitZoom() == true) action = 'resize';

	        // the cause of the resize event is used to choose the approach to updating the scalebar text
	        var zoom = viewport.getViewZoom();
	        var MPP = viewport.getBaseMPP() * zoom; // microns/pixel = base level microns/pixel x current zoom
	        if (action == 'zoom') {
	            //    - on an action of zoom the scale bar length in MICRONS is the reference
	            var scaleLenMic = scaleLenMicCur_ * zoom / viewport.getViewPrevZoom();
	            var scaleBarLenPx = scaleLenMic / MPP; // scale bar length in pxiels - for this zoom
	        } else {
	            //    - on action of user resize the scale bar length in PIXELS is the reference
	            var scaleBarLenPx = jScaleBarOuter.width(); // the outer div defines the width
	            jScaleBar.width(scaleBarLenPx); // set the inner div width to that of the outer
	            var scaleLenMic = scaleBarLenPx * MPP; // scale bar length in microns
	        }

	        if (scaleLenMicCur_ == scaleLenMic) // if nothing has changed, return now
	            return;

	        jMagDiv.text(viewport.getViewMag() + 'x'); // update the mag report
	        if (bReportPixels_ == true) jTextDiv.text(Math.round(scaleBarLenPx) + ' px'); // update the scale report in pixels
	        else jTextDiv.text(Math.round(scaleLenMic) + ' um'); // update the scale report in microns

	        scaleLenMicCur_ = scaleLenMic; // save the current state info
	        bIsFitZoomCur_ = viewport.isFitZoom();
	        //debug-only viewport.log('scalebar: resize: ' + viewport.getViewMag() + 'x   ' + scaleLenMic + ' microns ' + scaleBarLenPx + ' px');
	    };
	    //............................................ rotate() public
	    //    This function rotates the scale bar to the speicified absolute or relative (incremental) angle.
	    //    parameters:
	    //        nDegrees    : angle in degrees
	    //        relOrAbs    : { 'relative or 'absolute' }
	    //                        if 'relative' the label is rotated the current angle + nDegrees clockwise
	    //                        if 'absolute' the label is rotated nDegrees clockwise
	    self.rotate = function (nDegrees, relOrAbs) {
	        angleDeg = relOrAbs == 'relative' ? (+angleDeg + nDegrees) % 360 : +nDegrees;
	        (0, _helpers.divRotate)(jScaleBar[0], 0, 0, jScaleBar.width(), jScaleBar.height(), angleDeg * _defines2.default.Deg2Rad);
	        angleTextWrite_();
	        //viewport.log('scalebar: rotate: angle: ' + angleDeg + ' deg');
	    };

	    //............................................ rotateToCursor() public
	    //    This function rotates the scale bar to the angle of the cursor with the scale bar center.
	    self.rotateToCursor = function (e) {
	        if (viewport.navModeGet() == _defines2.default.eNavModes.nmRotatingOverlay) {
	            var thisAngleRad = Math.atan2(-(crBox_.cy - e.pageY), e.pageX - crBox_.cx);

	            if (thisAngleRad > _defines2.default.PI_2) thisAngleRad = _defines2.default.PI_2; // limit the rotation between -90 to +90 degrees
	            else if (thisAngleRad < -_defines2.default.PI_2) thisAngleRad = -_defines2.default.PI_2;
	            var thisAngleDeg = (thisAngleRad * _defines2.default.Rad2Deg).toFixed(2);
	            if (Math.abs(thisAngleDeg - angleDeg) < 0.5) // if the angle hasn't changed much, do nothing
	                return;

	            (0, _helpers.divRotate)(jScaleBar[0], 0, 0, jScaleBar.width(), jScaleBar.height(), thisAngleRad);
	            //debug-only viewport.log('scalebar: rotateToCursor: current angle: ' + angleDeg + ' deg  new:' + thisAngleDeg + ' deg');
	            angleDeg = thisAngleDeg; // save current scalebar angle
	            angleTextWrite_(); // update angle readout
	        }
	    };
	    //............................................ angleTextWrite_() local
	    var angleTextWrite_ = function angleTextWrite_() {

	        var str = '<p>' + Math.round(angleDeg) + '<sup>o</sup></p>';
	        jKnobText.html(str);
	    };
	    //............................................ crBoxSet_() local
	    // This function sets the bounding box of the rotated scale bar.
	    var crBoxSet_ = function crBoxSet_() {

	        if (angleDeg == 0.0) {
	            var offset = jScaleBar.offset();
	            crBox_ = new _objects.cRect(offset.left, offset.top, jScaleBar.width(), jScaleBar.height()); ///actually do this at any new positioning
	        } else {
	            // rotate the scale bar back to 0 to get the initial crBox_
	            var thisAngleRad = angleDeg * _defines2.default.Deg2Rad;

	            crBox_ = (0, _helpers.divRotate)(jScaleBar[0], 0, 0, jScaleBar.width(), jScaleBar.height(), 0);
	            var offset = jScaleBar.offset();
	            crBox_.addxy(offset.left, offset.top);
	            // return the scale bar to its rotated angle
	            (0, _helpers.divRotate)(jScaleBar[0], 0, 0, jScaleBar.width(), jScaleBar.height(), thisAngleRad);
	        }
	        //debug-only consoleWrite('crBoxSet_: ' + angleDeg + ' deg: ' + crBox_.toString());
	        return crBox_;
	    };

	    //............................................ load_() local
	    //    This function loads/creates the scale bar and calls into the layout manager
	    //        to position it according to its layout settings.
	    var load_ = function load_() {
	        if (jScaleBar) return; // if this viewport already has a scale bar, return
	        jScaleBar = jVpDiv.find('.' + _defines2.default.clsDIVSCALEBAR); // select the scale bar
	        if (jScaleBar.length) return; // if a match was found, return

	        var mag = viewport.getViewMag();
	        var baseMag = viewport.getBaseMag();

	        //debug-only viewport.log('scalebar: load_: mag: ' + mag + '  baseMag: ' + baseMag);
	        var initPosX = 0,
	            initPosY = 0; // initial position does not matter if using layout control

	        var scaleDef = scaleBarSpecs.micronsAt20x;
	        if (baseMag > 80) scaleDef = scaleBarSpecs.micronsAt100x;else if (baseMag > 30) scaleDef = scaleBarSpecs.micronsAt40x;

	        var scaleLenMic = scaleDef * viewport.getViewZoom(); // start with a default length in microns
	        scaleLenMic = Math.round(scaleLenMic / scaleDef) * scaleDef;
	        scaleLenMicCur_ = scaleLenMic; // save the current scale bar length in microns
	        bIsFitZoomCur_ = viewport.isFitZoom(); // save whether the current zoom is fit or not

	        var MPP = viewport.getBaseMPP() * viewport.getViewZoom(); // microns/pixel = base level microns/pixel x current zoom
	        var scaleBarLenPx = scaleLenMic / MPP; // scale bar length in pxiels - for this zoom
	        //debug-only viewport.log('scalebar: load_: len in pix: ' + scaleBarLenPx);

	        jScaleBarOuter = $('<div/>', { // build the outer scale bar div
	            'class': _defines2.default.clsDIVOUTERSCALEBAR + ' ' + _defines2.default.clsOVERLAY,
	            'title': 'Scale Bar:\r  Moves, Resizes and Rotates',
	            css: {
	                'left': initPosX + 'px',
	                'top': initPosY + 'px'
	            }
	        });

	        jScaleBar = $('<div/>', { // build the inner scale bar div
	            'class': _defines2.default.clsDIVSCALEBAR,
	            css: {
	                'width': scaleBarLenPx + 'px'
	            }
	        });

	        // note that the text must be in its own div or the resize handle gets hidden
	        jMagDiv = $('<span/>', { 'class': _defines2.default.clsDIVSCALEMAG, text: mag + 'x' });
	        if (bReportPixels_) {
	            jTextDiv = $('<span/>', { 'class': _defines2.default.clsDIVSCALETEXT, text: ' ' + Math.round(scaleBarLenPx) + ' px' });
	        } else {
	            jTextDiv = $('<span/>', { 'class': _defines2.default.clsDIVSCALETEXT, text: ' ' + scaleLenMic + ' um' });
	        }

	        jRotateKnob = $('<div/>', {
	            'class': _defines2.default.clsSBROTKNOB,
	            'title': 'Scale Bar Rotation:\r   Drag starting here to rotate.\r   Double click to reset rotation and position.'
	        });
	        jKnobText = $('<div/>', { 'class': _defines2.default.clsSBROTKNOBANGLE });

	        if (viewport.getCaptureType() == _defines2.default.eAICCaptureType.aic_i_FL) {
	            // if image is FL change styles for visibility
	            jScaleBar.css({ 'color': '#fff' });
	            jTextDiv.css({ 'background-color': '#111', 'border': '2px solid #fff', 'border-bottom': 'hidden' });
	            jMagDiv.css({ 'background-color': '#666' });
	            jRotateKnob.css({ 'background-color': '#111', 'border': '2px solid #fff', 'border-bottom': 'hidden' });
	        }

	        jScaleBar.append(jMagDiv); // place the mag text div in the scaleBar
	        jScaleBar.append('<div class="scaledivider"></div>'); // horizontal break
	        jScaleBar.append(jTextDiv); // place the scale text div in the scaleBar

	        jRotateKnob.append(jKnobText);
	        jScaleBar.append(jRotateKnob); // place the rotation knob div in the scaleBar

	        jScaleBarOuter.append(jScaleBar); // place the inner scale bar div in its outer
	        jVpDiv.append(jScaleBarOuter); // place the outer scale bar div in the viewport

	        viewport.overLayout.add(layout); // and call into layout with parms to place the div
	        crBoxSet_(); // initialize the bounding box

	        isLoaded = true;
	        self.show(true); // show/hide according to user preferences
	        bindEvents_(); // add event handlers
	        return;
	        //..................................................
	        // closure functions
	        //............................................ bindEvents_()
	        // bindEvents_ - This function adds the scale bar event handlers.
	        //
	        //    Note that by using the same namespace as the viewport when the
	        //    viewport removes its events by namespace, these are also removed.

	        function bindEvents_() {
	            var namespace = viewport.eventNameSpaceGet();

	            // show/hide scaleBar on mode change
	            $(_defines2.default.idHashROOT).on(_defines2.default.evMODECHANGE + namespace, function (e, parms) {
	                //debug-only viewport.log('scalebar: evMODECHANGE: ' + parms.navModePrev + ' to ' + parms.navMode);

	                // show is true unless the navMode is one that the scale bar is supposed to hide during
	                var bshow = navModesImHiddenIn[parms.navMode] == undefined ? true : false;
	                self.show(bshow);

	                // ?????? jKnobText.hide();
	            });

	            $(_defines2.default.idHashROOT).on(_defines2.default.evZOOMCHANGE + namespace, function (e, parms) {
	                if (viewport.getImageId() == parms.imageId) {
	                    self.resize('zoom');
	                }
	            });

	            // show/hide scaleBar if image is selected/not-selected
	            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
	                // show is true unless the navMode is one that the scale bar is supposed to hide during
	                var bshow = navModesImHiddenIn[parms.navMode] == undefined ? true : false;
	                //debug-only viewport.log('scalebar: evIMAGESELECTED: bshow: ' +bshow);
	                self.show(bshow);
	            });

	            // user preference update
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSREADY + namespace, function (e, parms) {
	                //viewport.log('ScaleBar us.evUSERPREFSREADY recvd');
	                self.show(uScope.prefGet(_defines2.default.clsDIVSCALEBAR));
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSET + namespace, function (e, parms) {
	                // parms: {className: STR, value: bool}
	                if (parms.className == _defines2.default.clsDIVSCALEBAR) {
	                    //viewport.log('ScaleBar us.evUSERPREFSET recvd');
	                    self.show(parms.value);
	                }
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function (e, parms) {
	                //viewport.log('ScaleBar us.evUSERPREFDEFAULTVISIBLE recvd');
	                uScope.prefSet(_defines2.default.clsDIVSCALEBAR, prefVisibleDef);
	            });

	            //..................................................  scale bar drag and resize related
	            jScaleBarOuter.draggable({
	                cursor: 'move',
	                containment: 'parent',
	                stop: function stop(event, ui) {
	                    crBoxSet_(); // update sb bounding box so public call has box up to date
	                    layout.canBePlaced = false; // reposition only when scalebar is not fully within view
	                }
	            });

	            jScaleBar.resizable({
	                cursor: 'move',
	                handles: 'e,w',
	                distance: 0,
	                alsoResize: jScaleBarOuter,
	                resize: function resize(e) {
	                    self.resize('resize');
	                    return false;
	                },
	                stop: function stop(event, ui) {
	                    crBoxSet_();
	                }
	            });

	            jScaleBar.on('mouseover' + namespace, function (e) {
	                // ..... mouseover event adds the scalebar's resize handles
	                if ($(this).attr('hasHandles') == undefined) {
	                    $(this).attr('hasHandles', true);
	                    var jchildren = $(this).eq(0).children();
	                    jchildren.each( //
	                    function (idx) {
	                        var aclass = $(this).attr('class');
	                        if (aclass.indexOf('ui-resizable-e') != -1 || aclass.indexOf('ui-resizable-w') != -1) {
	                            $(this).addClass('ui-icon ui-icon-grip-solid-vertical');
	                        }
	                    });
	                }
	            });

	            //..................................................  scale bar rotation related

	            {
	                // configure rotation
	                var resetToZero = function resetToZero(e) {
	                    // set rotation to 0 degrees and place in default location
	                    layout.canBePlaced = true; // allow layout to reposition the scalebar again
	                    self.rotate(0, 'absolute');
	                    reLayout(layout.precinct); // layout just this overlay's precinct
	                    e.preventDefault();
	                    return false;
	                };
	                var doRotateToCursor = function doRotateToCursor(e) {
	                    // ...... mouse move on knob or scale bar rotates the scalebar
	                    if (viewport.navModeGet() == _defines2.default.eNavModes.nmRotatingOverlay) {
	                        self.rotateToCursor(e); // scale bar rotation
	                        return false;
	                    }
	                };
	                var doHaltNav = function doHaltNav(e) {
	                    // ...... mouse up on knob or scale bar (or viewport) halts navigation
	                    if (viewport.navModeGet() == _defines2.default.eNavModes.nmRotatingOverlay) {
	                        _defines2.default.navModeHalt(viewport);
	                        return false;
	                    }
	                };

	                // ...... hover on knob shows rotation angle
	                jRotateKnob.on('hover' + namespace, function (e) {
	                    // debug-only viewport.log('jRotateKnob: hover: ' + e.type);
	                    if (e.type == 'mouseover' || e.type == 'mouseenter') {
	                        jKnobText.show();
	                        angleTextWrite_();
	                    } else {
	                        // e.type == 'mouseout' 'mouseleave'
	                        jKnobText.hide();
	                    }
	                    return false;
	                });

	                jRotateKnob.on('mousedown' + namespace, function (e) {
	                    // ...... mouse down on knob starts rotation
	                    _defines2.default.navModeSwitch(viewport, _defines2.default.eNavModes.nmRotatingOverlay);
	                    crBoxSet_(); // initialize the scale bar's bounding box at the start of rotation
	                    return false;
	                });

	                jRotateKnob.on('dblclick' + namespace, resetToZero);
	                jKnobText.on('dblclick' + namespace, resetToZero);
	                jKnobText.on('click' + namespace, resetToZero);

	                jRotateKnob.on('mousemove' + namespace, doRotateToCursor);
	                jScaleBar.on('mousemove' + namespace, doRotateToCursor);

	                jRotateKnob.on('mouseup' + namespace, doHaltNav);
	                jScaleBar.on('mouseup' + namespace, doHaltNav);
	            }
	        }
	        //..................................................
	    };
	    //............................................ construction.
	    construct_();
	}
	module.exports = exports['default'];

/***/ }

});